/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import type { Coordinates } from '@volkswagen-onehub/audi-feature-service-visitor-locator';
import type { SearchParams } from '../models/common/searchParams';
import historyContext from '../contexts/history-context';

export function useInitialQueryParams() {
  const DEFAULT_HASHCODES = ['#filters', '#extractappid'];
  const { historyService } = historyContext.useHistoryState();

  const parseInitialParams = (): SearchParams => {
    function extractURLHashValue() {
      let param = '';
      if (typeof window !== 'undefined') {
        param = JSON.parse(decodeURIComponent(window.location.hash).split(/=(.+)/)[1]);
      }
      let str = Object.values(param)[0];
      str = str.substring(1);
      return new URLSearchParams(str);
    }
    let searchParams;
    if (historyService?.history && typeof window !== 'undefined') {
      if (
        !historyService.history.location.search &&
        window.location.hash &&
        !DEFAULT_HASHCODES.includes(window.location.hash)
      ) {
        try {
          searchParams = extractURLHashValue();
        } catch {
          searchParams = undefined;
        }
      } else {
        searchParams = historyService.history.location.search
          ? new URLSearchParams(historyService.history.location.search)
          : new URLSearchParams(window.location.search);
      }

      if (!searchParams) {
        return {
          query: '',
          filters: [],
          'triggered-by-teaser': false,
          'dealer-id': null,
          'search-geolocation': { lat: 0, lng: 0 },
          selected: null,
          country: null,
          favorite: null,
          reviews: false,
          radius: '',
        };
      }

      const searchGeolocation: Coordinates =
        searchParams.get('geolocation-lat') && searchParams.get('geolocation-lng')
          ? {
              lat: Number(searchParams.get('geolocation-lat')),
              lng: Number(searchParams.get('geolocation-lng')),
            }
          : { lat: 0, lng: 0 };
      return {
        query: searchParams?.get('query') ?? '',
        radius: searchParams?.get('radius') ?? undefined,
        filters: searchParams?.get('filters')?.split(',') ?? [],
        'triggered-by-teaser': searchParams?.get('triggered-by-teaser') === 'true',
        'dealer-id': searchParams?.get('dealer-id') ?? null,
        'search-geolocation': searchGeolocation ?? { lat: 0, lng: 0 },
        selected: searchParams?.get('selected') ?? null,
        country: searchParams?.get('country') ?? null,
        favorite: searchParams?.get('favorite') ?? null,
        reviews: searchParams?.get('reviews') === 'true',
      };
    }

    return {
      query: '',
      radius: undefined,
      filters: [],
      'triggered-by-teaser': false,
      'dealer-id': null,
      'search-geolocation': { lat: 0, lng: 0 },
      selected: null,
      country: null,
      favorite: null,
      reviews: false,
    };
  };

  return {
    parseInitialParams,
  };
}
